import { DateTime } from "luxon";

import { yearsAgo } from "shared/utils/dates";

export const PatientSexAge = (props: any) => {
  const { patient, shouldDisplayDOB = true } = props;

  const sexDisplay = patient?.sex ? (
    <span title="HL7 single character representation of sex: F, M, O, U, A, N">
      {patient.sex}
    </span>
  ) : (
    <span title="Unknown sex">?</span>
  );

  const formattedDOB = shouldDisplayDOB && (
    <>
      {" — "}
      <span title="Date of birth">
        {DateTime.fromISO(patient.date_of_birth).toLocaleString()}
      </span>
    </>
  );

  const ageDisplay =
    patient?.date_of_birth && patient.date_of_birth !== "1900-01-01" ? (
      <span className="age">
        <span title="Age">
          {yearsAgo(DateTime.fromISO(patient.date_of_birth))}
        </span>
        {formattedDOB}
      </span>
    ) : (
      <span title="Unknown age"> ?</span>
    );

  return (
    <span>
      {sexDisplay}/{ageDisplay}
    </span>
  );
};

export default PatientSexAge;
